export default "__VITE_ASSET__CmPzhf4f__"